import api from './client';
import type { AdminUser } from '../types';

export const gdprApi = {
  searchUsers: (q: string) =>
    api.get<AdminUser[]>('/api/admin/gdpr/users', { params: { q } }),

  /** Pobiera JSON jako Blob — wymusza download w UI. */
  exportUser: (userId: string) =>
    api.get(`/api/admin/gdpr/users/${userId}/export`, { responseType: 'blob' }),

  anonymizeUser: (userId: string) =>
    api.post(`/api/admin/gdpr/users/${userId}/anonymize`),
};
